var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.currentTab,
            callback: function ($$v) {
              _vm.currentTab = $$v
            },
            expression: "currentTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("BC.BCInfo"), name: "1" } },
            [
              _c(
                "div",
                { staticClass: "searchBox_top" },
                [
                  _vm.canSave
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "acl",
                              rawName: "v-acl",
                              value: _vm.SaveBc,
                              expression: "SaveBc",
                            },
                          ],
                          attrs: { type: "primary" },
                          on: { click: _vm.saveDetail },
                        },
                        [_vm._v(_vm._s(_vm.$t("BC.saveDraft")))]
                      )
                    : _vm._e(),
                  _vm.canSave
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "acl",
                              rawName: "v-acl",
                              value: _vm.SubmitBc,
                              expression: "SubmitBc",
                            },
                          ],
                          attrs: { type: "primary" },
                          on: { click: _vm.submitDetail },
                        },
                        [_vm._v(_vm._s(_vm.$t("BC.submit")))]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.canAppr &&
                            _vm.status == "appr_in" &&
                            _vm.emplFlag != "SUP",
                          expression:
                            "canAppr && status == 'appr_in' && emplFlag != 'SUP'",
                        },
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.CompleteBc,
                          expression: "CompleteBc",
                        },
                      ],
                      attrs: { type: "primary" },
                      on: { click: _vm.approvalFun },
                    },
                    [_vm._v(_vm._s(_vm.$t("BC.audit")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.historyBack },
                    },
                    [_vm._v(_vm._s(_vm.$t("BC.close")))]
                  ),
                  _vm.canSave
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "acl",
                              rawName: "v-acl",
                              value: _vm.DirectBc,
                              expression: "DirectBc",
                            },
                          ],
                          attrs: { type: "primary" },
                          on: { click: _vm.onComplete },
                        },
                        [_vm._v("Complete")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-form",
                {
                  ref: "DetailForm",
                  attrs: {
                    model: _vm.DetailForm,
                    rules: _vm.DetailRules,
                    "label-width": "160px",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("BC.createBy"),
                                prop: "creator",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { clearable: "", disabled: "" },
                                model: {
                                  value: _vm.DetailForm.creator,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.DetailForm,
                                      "creator",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "DetailForm.creator",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("BC.createDate"),
                                prop: "createDate",
                              },
                            },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  "value-format": "yyyy-MM-dd",
                                  type: "date",
                                  disabled: "",
                                },
                                model: {
                                  value: _vm.DetailForm.createDate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.DetailForm, "createDate", $$v)
                                  },
                                  expression: "DetailForm.createDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("BC.BCNumber"),
                                prop: "serialNo",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { clearable: "", disabled: "" },
                                model: {
                                  value: _vm.DetailForm.serialNo,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.DetailForm,
                                      "serialNo",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "DetailForm.serialNo",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("BC.status"),
                                prop: "status",
                              },
                            },
                            [
                              _c("ic-select", {
                                attrs: {
                                  clearable: "",
                                  table: "TT_BC",
                                  field: "STATUS",
                                  disabled: "",
                                  placeholder: _vm.$t("BC.sel"),
                                },
                                model: {
                                  value: _vm.DetailForm.status,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.DetailForm, "status", $$v)
                                  },
                                  expression: "DetailForm.status",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("BC.SSRNumber"),
                                prop: "ssrNo",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  disabled: !_vm.canSave,
                                },
                                on: {
                                  blur: function ($event) {
                                    return _vm.querySsrByNo($event, "SSR")
                                  },
                                  clear: _vm.clearSsrByNo,
                                },
                                model: {
                                  value: _vm.DetailForm.ssrNo,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.DetailForm,
                                      "ssrNo",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "DetailForm.ssrNo",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("BC.RFPNumber"),
                                prop: "rfpNo",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  disabled: !_vm.canSave,
                                },
                                on: {
                                  blur: function ($event) {
                                    return _vm.querySsrByNo($event, "RFP")
                                  },
                                  clear: _vm.clearSsrByNo,
                                },
                                model: {
                                  value: _vm.DetailForm.rfpNo,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.DetailForm,
                                      "rfpNo",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "DetailForm.rfpNo",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _vm.DetailForm.ssrNo ||
                          _vm.DetailForm.rfpNo ||
                          _vm.status == "appr_pass" ||
                          _vm.status == "appr_in"
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("BC.Category1"),
                                    prop: "oneLevelCategoryIds",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        multiple: "",
                                        disabled: "",
                                        placeholder: _vm.$t("BC.sel"),
                                      },
                                      on: {
                                        "visible-change": _vm.changeCategory1,
                                        "remove-tag": _vm.removeCategory1,
                                      },
                                      model: {
                                        value:
                                          _vm.DetailForm.oneLevelCategoryIds,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.DetailForm,
                                            "oneLevelCategoryIds",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "DetailForm.oneLevelCategoryIds",
                                      },
                                    },
                                    _vm._l(
                                      _vm.categoryList1,
                                      function (item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: item.name,
                                            value: item.tmCategoryId,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("BC.Category1"),
                                    prop: "oneLevelCategoryIds",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        multiple: "",
                                        placeholder: _vm.$t("BC.sel"),
                                      },
                                      on: {
                                        "visible-change": _vm.changeCategory1,
                                        "remove-tag": _vm.removeCategory1,
                                      },
                                      model: {
                                        value:
                                          _vm.DetailForm.oneLevelCategoryIds,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.DetailForm,
                                            "oneLevelCategoryIds",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "DetailForm.oneLevelCategoryIds",
                                      },
                                    },
                                    _vm._l(_vm.categoryList1, function (item) {
                                      return _c("el-option", {
                                        key: item.categoryLevel1Id,
                                        attrs: {
                                          label: item.categoryLevel1Name,
                                          value: item.categoryLevel1Id,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _vm.DetailForm.ssrNo ||
                          _vm.DetailForm.rfpNo ||
                          _vm.status == "appr_pass" ||
                          _vm.status == "appr_in"
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("BC.Category2"),
                                    prop: "twoLevelCategoryIds",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        multiple: "",
                                        disabled: "",
                                        placeholder: _vm.$t("BC.sel"),
                                      },
                                      model: {
                                        value:
                                          _vm.DetailForm.twoLevelCategoryIds,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.DetailForm,
                                            "twoLevelCategoryIds",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "DetailForm.twoLevelCategoryIds",
                                      },
                                    },
                                    _vm._l(
                                      _vm.categoryList2,
                                      function (item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: item.name,
                                            value: item.tmCategoryId,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("BC.Category2"),
                                    prop: "twoLevelCategoryIds",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        multiple: "",
                                        placeholder: _vm.$t("BC.sel"),
                                      },
                                      model: {
                                        value:
                                          _vm.DetailForm.twoLevelCategoryIds,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.DetailForm,
                                            "twoLevelCategoryIds",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "DetailForm.twoLevelCategoryIds",
                                      },
                                    },
                                    _vm._l(
                                      _vm.categoryList2,
                                      function (item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: item.categoryLevel2Name,
                                            value: item.categoryLevel2Id,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("BC.supplier"),
                                prop: "supplierName",
                              },
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  staticClass: "handle-input",
                                  attrs: {
                                    clearable: "",
                                    disabled: !_vm.canSave,
                                  },
                                  on: { clear: _vm.clearSupplierId },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.showSelSupplierDialogFun(
                                        _vm.canSave
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.DetailForm.supplierName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.DetailForm,
                                        "supplierName",
                                        $$v
                                      )
                                    },
                                    expression: "DetailForm.supplierName",
                                  },
                                },
                                [
                                  _c("el-divider", {
                                    attrs: {
                                      slot: "suffix",
                                      direction: "vertical",
                                    },
                                    slot: "suffix",
                                  }),
                                  _c("i", {
                                    staticClass:
                                      "el-icon-search el-input_icon pointerCss",
                                    attrs: {
                                      slot: "suffix",
                                      disabled: !_vm.canSave,
                                    },
                                    slot: "suffix",
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("BC.projectName"),
                                prop: "projectName",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  disabled: !_vm.canSave,
                                },
                                model: {
                                  value: _vm.DetailForm.projectName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.DetailForm, "projectName", $$v)
                                  },
                                  expression: "DetailForm.projectName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _vm.emplFlag != "SUP"
                        ? _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("BC.isApproval"),
                                    prop: "needCfoApprover",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        placeholder: _vm.$t("BC.sel"),
                                        disabled: "",
                                      },
                                      model: {
                                        value: _vm.DetailForm.needCfoApprover,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.DetailForm,
                                            "needCfoApprover",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "DetailForm.needCfoApprover",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t("BC.yes"),
                                          value: "true",
                                        },
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t("BC.no"),
                                          value: "false",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.emplFlag == "SUP"
                        ? _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("BC.SubmitBy"),
                                    prop: "approverId",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        clearable: "",
                                        disabled: !_vm.canSave,
                                        placeholder: _vm.$t("BC.sel"),
                                      },
                                      model: {
                                        value: _vm.DetailForm.approverId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.DetailForm,
                                            "approverId",
                                            $$v
                                          )
                                        },
                                        expression: "DetailForm.approverId",
                                      },
                                    },
                                    _vm._l(
                                      _vm.SubmitBySSList,
                                      function (item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: item.userName,
                                            value: item.tmUserId,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("BC.cqsApprover"),
                                prop: "cqsApproverId",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    clearable: "",
                                    disabled: !_vm.canSave,
                                    placeholder: _vm.$t("BC.sel"),
                                  },
                                  model: {
                                    value: _vm.DetailForm.cqsApproverId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.DetailForm,
                                        "cqsApproverId",
                                        $$v
                                      )
                                    },
                                    expression: "DetailForm.cqsApproverId",
                                  },
                                },
                                _vm._l(
                                  _vm.SubmitByCQSList,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.tmUserId,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.status == "draft" || _vm.status == "appr_back",
                      expression: "status == 'draft' || status == 'appr_back'",
                    },
                  ],
                  staticClass: "box-card",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("BC.businessTemplate"))),
                      ]),
                    ]
                  ),
                  _c(
                    "el-table",
                    {
                      staticClass: "table",
                      attrs: {
                        data: _vm.TemplateList,
                        border: "",
                        "highlight-current-row": "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          prop: "documentName",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-link",
                                  {
                                    attrs: { type: "primary" },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.downloadTemplate(
                                          scope.row.path,
                                          scope.row.name
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(scope.row.name) + " ")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                { staticClass: "box-card" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t("BC.businessPDF")))])]
                  ),
                  _c(
                    "el-table",
                    {
                      staticClass: "table",
                      attrs: {
                        data: _vm.PDFlist,
                        border: "",
                        "highlight-current-row": "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          prop: "documentName",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-link",
                                  {
                                    attrs: { type: "primary" },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.downloadFile(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(scope.row.documentName) + " ")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm.canSave
                        ? _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              prop: "tmDocumentId",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-link",
                                        {
                                          attrs: { type: "primary" },
                                          nativeOn: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.deleteFile(
                                                scope.row.tmDocumentId,
                                                scope.$index,
                                                _vm.PDFlist
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("common.del")))]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3388066712
                            ),
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.uploadStatus && _vm.canSave
                    ? _c(
                        "el-upload",
                        {
                          ref: "upload",
                          attrs: {
                            action: "upload",
                            "http-request": _vm.uploadConfirm,
                            "before-upload": _vm.beforePDFUpload,
                            "show-file-list": true,
                            "file-list": _vm.fileList,
                            multiple: "",
                            accept: ".PDF",
                            limit: 1,
                            name: "file",
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                slot: "trigger",
                                size: "small",
                                type: "primary",
                              },
                              slot: "trigger",
                            },
                            [_vm._v(_vm._s(_vm.$t("BC.selectFile")))]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("BC.approvalLog"), name: "2" } },
            [
              _c(
                "el-table",
                {
                  staticClass: "table",
                  attrs: {
                    data: _vm.auditLog,
                    border: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "createDate",
                      label: _vm.$t("BC.OperationTime"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm._f("dateFormatFilter")(
                                  scope.row.createDate,
                                  "YYYY-MM-DD HH:mm:ss"
                                )
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "operatorName",
                      label: _vm.$t("BC.OperatorName"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "action",
                      label: _vm.$t("BC.PedagogicalOperation"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "comments",
                      label: _vm.$t("BC.opinion"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showSelSupplierDialog,
            "append-to-body": "",
            width: "70%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showSelSupplierDialog = $event
            },
          },
        },
        [
          _vm.SupplierNameDialogReset
            ? _c("SelSupplier", {
                ref: "supplierSelRef",
                attrs: { multipleSelectionFlag: true },
                on: { subCallMethod: _vm.selectSupplierMethod },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.CQSCategoryLeader
              ? _vm.$t("BC.reviewOperationWindow")
              : _vm.$t("BC.approvalWindow"),
            visible: _vm.approvalVisible,
            width: "34%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.approvalVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "approvaForm",
              attrs: {
                model: _vm.approvaForm,
                rules: _vm.approvaRules,
                inline: "",
                "label-width": "160px",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.CQSCategoryLeader
                      ? _vm.$t("BC.reviewer")
                      : _vm.$t("BC.auditor"),
                    prop: "auditor",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.approvaForm.auditor,
                      callback: function ($$v) {
                        _vm.$set(_vm.approvaForm, "auditor", $$v)
                      },
                      expression: "approvaForm.auditor",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.CQSCategoryLeader
                      ? _vm.$t("BC.reviewTime")
                      : _vm.$t("BC.approvalTime"),
                    prop: "approvalTime",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.approvaForm.approvalTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.approvaForm, "approvalTime", $$v)
                      },
                      expression: "approvaForm.approvalTime",
                    },
                  }),
                ],
                1
              ),
              _vm.needAutoSave
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("BC.Category1"),
                        prop: "oneLevelCategoryIds",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            multiple: "",
                            disabled: "",
                            placeholder: _vm.$t("BC.sel"),
                          },
                          on: {
                            "visible-change": _vm.changeCategory1,
                            "remove-tag": _vm.removeCategory1,
                          },
                          model: {
                            value: _vm.DetailForm.oneLevelCategoryIds,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.DetailForm,
                                "oneLevelCategoryIds",
                                $$v
                              )
                            },
                            expression: "DetailForm.oneLevelCategoryIds",
                          },
                        },
                        _vm._l(_vm.categoryList1, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.name,
                              value: item.tmCategoryId,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.needAutoSave
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("BC.Category2"),
                        prop: "twoLevelCategoryIds",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            multiple: "",
                            disabled: "",
                            placeholder: _vm.$t("BC.sel"),
                          },
                          model: {
                            value: _vm.DetailForm.twoLevelCategoryIds,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.DetailForm,
                                "twoLevelCategoryIds",
                                $$v
                              )
                            },
                            expression: "DetailForm.twoLevelCategoryIds",
                          },
                        },
                        _vm._l(_vm.categoryList2, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.name,
                              value: item.tmCategoryId,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.needAutoSave
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("BC.isApproval"),
                        prop: "needCfoApprover",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t("BC.sel"),
                            disabled: "",
                          },
                          model: {
                            value: _vm.DetailForm.needCfoApprover,
                            callback: function ($$v) {
                              _vm.$set(_vm.DetailForm, "needCfoApprover", $$v)
                            },
                            expression: "DetailForm.needCfoApprover",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: _vm.$t("BC.yes"), value: "true" },
                          }),
                          _c("el-option", {
                            attrs: { label: _vm.$t("BC.no"), value: "false" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.needAutoSave
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("BC.cqsApprover"),
                        prop: "cqsApproverId",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            clearable: "",
                            disabled: !_vm.canSave,
                            placeholder: _vm.$t("BC.sel"),
                          },
                          model: {
                            value: _vm.DetailForm.cqsApproverId,
                            callback: function ($$v) {
                              _vm.$set(_vm.DetailForm, "cqsApproverId", $$v)
                            },
                            expression: "DetailForm.cqsApproverId",
                          },
                        },
                        _vm._l(_vm.SubmitByCQSList, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.userName,
                              value: item.tmUserId,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.CQSCategoryLeader
                      ? _vm.$t("BC.RevisionComments")
                      : _vm.$t("BC.approvalResults"),
                    prop: "approvalResults",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.ResultsChange },
                      model: {
                        value: _vm.approvaForm.approvalResults,
                        callback: function ($$v) {
                          _vm.$set(_vm.approvaForm, "approvalResults", $$v)
                        },
                        expression: "approvaForm.approvalResults",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "PASS" } }, [
                        _vm._v(_vm._s(_vm.$t("BC.pass"))),
                      ]),
                      _c("el-radio", { attrs: { label: "REJECT" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.CQSCategoryLeader
                              ? _vm.$t("BC.have")
                              : _vm.$t("BC.noPass")
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("BC.RevisionComments"),
                    prop: "approvalRemarks",
                    rules:
                      _vm.approvaForm.approvalResults == "REJECT"
                        ? _vm.approvaForm.approvalRemarks
                        : [],
                  },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 2, maxRows: 4 },
                      maxlength: "300",
                    },
                    model: {
                      value: _vm.approvaForm.approvalRemarks,
                      callback: function ($$v) {
                        _vm.$set(_vm.approvaForm, "approvalRemarks", $$v)
                      },
                      expression: "approvaForm.approvalRemarks",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.approvalVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("BC.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.approvalConfirm()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("BC.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }